var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ModalRuleCheckViolations',{attrs:{"violations":_vm.violationMessages,"featureDismissViolationEnabled":_vm.featureDismissViolationEnabled},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}})
}
var staticRenderFns = []

export { render, staticRenderFns }